/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Guide_DescriptionInputs */



/**
* | output |
* | --- |
* | "Follow these instructions to configure SCIM with your identity provider" |
*
* @param {Scim_Setup_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_guide_description = /** @type {((inputs?: Scim_Setup_Guide_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Guide_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Folgen Sie diesen Anweisungen, um SCIM mit Ihrem Identitätsanbieter zu konfigurieren")
	return /** @type {LocalizedString} */ ("Follow these instructions to configure SCIM with your identity provider")
});